export default __webpack_public_path__ + "static/media/BRAKUJE_WAM.a2afeee2.png";